import _extends from "@babel/runtime/helpers/extends";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor, _descriptor2, _SourceOperandValueEditor;
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { Expression } from "abreact/expression/Expression";
import { InlinePanelLayout } from "abreact/expression/layout/InlinePanelLayout";
import { GuidedExpressionEditor } from "abreact/expression/ui/editor/GuidedExpressionEditor";
import { OperandValueEditor } from "abreact/expression/ui/editor/impl/condition/operandValue/operand/OperandValueEditor";
import { OperatorOperandValueImpl } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/OperatorOperandValueImpl";
import { ReferenceOperandValueImpl } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/ReferenceOperandValueImpl";
import { GuidedExpressionEditorUtils } from "abreact/expression/ui/editor/impl/utils/GuidedExpressionEditorUtils";
import { AbBooleanLogicTreeFocus } from "abreact/incubator/ui/abBooleanLogicTree/AbBooleanLogicTreeFocus";
import { useComponentWithManagedFocus } from "abreact/incubator/ui/abBooleanLogicTree/AbGenericFocusManager";
import { ForwardFocusRef } from "abreact/incubator/ui/utils/FocusUtils";
import { AbMultiplexInput } from "abreact/input/AbMultiplexInput";
import { Assert } from "abweb/utils/Assert";
import { ObjectUtils } from "abweb/utils/ObjectUtils";
import { action, computed, makeObservable, observable, reaction } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { useMemo } from "react";
// import AbstractOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.AbstractOperandValue;
// import OperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.OperandValue;
// import OperatorOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.OperatorOperandValue;
// import DisplayProps = GuidedExpressionEditor.Operand.Value.Editor.DisplayProps;
// import DragDrop = GuidedExpressionEditor.Operand.Value.Editor.DragDrop;
// import SourceOperand = GuidedExpressionEditor.SourceOperand;
// import SourceTarget = AbBooleanLogicTreeFocus.SourceTarget;

export let SourceOperandValueEditor = (_dec = observable.ref, _dec2 = observable.ref, _dec3 = action.bound, _dec4 = action.bound, observer(_class = (_class2 = (_SourceOperandValueEditor = class SourceOperandValueEditor extends React.Component {
  constructor(props) {
    super(props);
    _initializerDefineProperty(this, "_sourceValueCategory", _descriptor, this);
    _initializerDefineProperty(this, "_dragDropEditorMachine", _descriptor2, this);
    _defineProperty(this, "_initializationTriggerDisposers", []);
    _defineProperty(this, "_functionSourceValueCategory", void 0);
    _defineProperty(this, "_sourceValueCategories", []);
    _defineProperty(this, "_forwardFocusRef", void 0);
    this.renderOperandValueEditor = this.renderOperandValueEditor.bind(this);
    this._forwardFocusRef = this.props.managedFocusRef ?? new ForwardFocusRef();
    makeObservable(this);
  }
  get dataTestId() {
    let dataTestId = "source";
    if (this.props.dataTestId) {
      dataTestId = `${this.props.dataTestId}-${dataTestId}`;
    }
    return dataTestId;
  }
  get valueCategoryID() {
    return this._sourceValueCategory?.id;
  }
  render() {
    if (this._sourceValueCategory == null) {
      return null;
    }
    const baseProps = {
      renderOperandValueEditor: this.renderOperandValueEditor,
      operandValue: this.props.operandValue,
      valueCategoryID: this.valueCategoryID,
      operandValueContext: {
        isSourceOperandValue: true
      },
      liveViewSliceModel: this.props.liveViewSliceModel,
      operatorOperandValue: this.props.operatorOperandValue,
      componentFactory: this.props.componentFactory,
      dataTestId: this.dataTestId
    };
    if (this.props.isReadonly) {
      return /*#__PURE__*/React.createElement(OperandValueEditor, _extends({
        isReadonly: true
      }, baseProps));
    } else {
      return /*#__PURE__*/React.createElement(OperandValueEditor, _extends({
        isReadonly: false
      }, baseProps, {
        dragDropEditorMachine: this._dragDropEditorMachine,
        generateId: this.props.generateId,
        applyOperandValue: this.props.applyOperandValue
      }));
    }
  }
  componentDidMount() {
    this.initialize();
    this.registerInitializationTrigger();
    this.applyTemplateConfigurationIfApplicable();
  }
  componentDidUpdate(previousProps) {
    if (!ObjectUtils.deepCompare(previousProps.expTemplateConfiguration, this.props.expTemplateConfiguration)) {
      this.initialize();
    }
  }
  componentWillUnmount() {
    this.disposeInitializationTriggers();
  }
  applyTemplateConfigurationIfApplicable() {
    if (!this.props.isReadonly && this.props.operandValue == null && this.props.expTemplateConfiguration != null) {
      const operandValue = ReferenceOperandValueImpl.fromExpTemplateConfiguration(this.props.generateId(), this.props.operandName, this.props.expTemplateConfiguration, this.props.expressionDomainModel);
      this.props.applyOperandValue(operandValue, {
        frameworkInitiated: true
      });
    }
  }
  registerInitializationTrigger() {
    /**
     * React to self (specifically, if a dropped operand value has a different value category than current selection).
     */
    this._initializationTriggerDisposers.push(reaction(() => this.props.operandValue, operandValue => {
      if (GuidedExpressionEditorUtils.isValueCategoryStale(operandValue, this.valueCategoryID, this.props.expTemplateConfiguration)) {
        this.initialize();
      }
    }, {
      equals: GuidedExpressionEditor.AbstractModel.AbstractRowModel.AbstractOperandValue.equals
    }));
  }
  disposeInitializationTriggers() {
    this._initializationTriggerDisposers.forEach(disposer => disposer());
  }
  initialize() {
    let expValueCategories;
    if (this.props.expTemplateConfiguration != null) {
      const {
        categoryID
      } = this.props.expTemplateConfiguration;
      Assert.assert(categoryID != null);
      const expValueCategory = this.props.expressionDomainModel.getExpValueCategory(categoryID);
      Assert.assert(!expValueCategory.excludeFromSourceInput);
      expValueCategories = [expValueCategory];
    } else {
      expValueCategories = this.props.componentFactory.getSourceOperandValueEditorCategories();
    }
    const sourceValueCategories = expValueCategories.map(expValueCategory => new SourceValueCategoryImpl(expValueCategory));
    this._sourceValueCategories = [...sourceValueCategories];
    let resolvedSourceValueCategory;
    this._functionSourceValueCategory = undefined;
    const {
      ROLE_FUNCTION
    } = Expression.Domain.Constants;
    const functionExpOperatorRole = this.props.expressionDomainModel.findExpOperatorRole(ROLE_FUNCTION);
    if (functionExpOperatorRole != null && functionExpOperatorRole.excludeFromSourceInput !== true) {
      if (this.props.expressionDomainModel.getExpOperatorsWithExpOperatorRole(ROLE_FUNCTION).length > 0) {
        this._functionSourceValueCategory = new FunctionSourceValueCategoryImpl();
        this._sourceValueCategories.push(this._functionSourceValueCategory);
      }
    }
    const {
      operandValue
    } = this.props;
    if (operandValue != null) {
      if (OperatorOperandValueImpl.isInstance(operandValue) && !operandValue.isFormula) {
        /**
         * This would be an invalid case: the domain has no functions, yet we end up here with an operator input,
         * indicating that the user chose a function?
         */
        Assert.assert(this._functionSourceValueCategory != null);
        resolvedSourceValueCategory = this._functionSourceValueCategory;
      } else {
        // Find the correct one based on category id
        const matchingSourceValueCategories = sourceValueCategories.filter(sourceValueCategory => {
          return sourceValueCategory.id === this.props.operandValue.valueCategoryID;
        });
        /**
         * This would be an invalid case: the value selected has a category that is not supported?
         */
        Assert.assert(matchingSourceValueCategories.length === 1);
        resolvedSourceValueCategory = matchingSourceValueCategories[0];
      }
    } else {
      if (this.props.expTemplateConfiguration != null) {
        for (let sourceValueCategory of sourceValueCategories) {
          if (sourceValueCategory.id === this.props.expTemplateConfiguration.categoryID) {
            resolvedSourceValueCategory = sourceValueCategory;
            break;
          }
        }
        Assert.assert(resolvedSourceValueCategory != null, `Invalid category ID on the template configuration: ${this.props.expTemplateConfiguration.categoryID}`);
      } else {
        resolvedSourceValueCategory = sourceValueCategories[0];
      }
    }
    this._sourceValueCategory = resolvedSourceValueCategory;
  }
  get editor() {
    let editor;
    if (this._sourceValueCategory === this._functionSourceValueCategory) {
      editor = this.props.componentFactory.getFunctionSourceOperandValueEditor(this.sourceOperandValueEditorProps);
    } else {
      editor = this.props.componentFactory.getSourceOperandValueEditor(this.sourceOperandValueEditorProps, this.valueCategoryID);
    }
    return /*#__PURE__*/React.createElement("span", {
      className: "ab-gee-source-operand-input-box",
      "data-test-id": `${this.dataTestId}-inputBox`
    }, editor);
  }
  renderOperandValueEditor() {
    if (this._sourceValueCategories.length === 1) {
      return this.editor;
    } else {
      return /*#__PURE__*/React.createElement(AbMultiplexInput, {
        key: this.dataTestId,
        value: this._sourceValueCategory,
        items: this._sourceValueCategories,
        itemRenderer: sourceValueCategory => sourceValueCategory.selectorLabel ?? sourceValueCategory.label,
        valueRenderer: sourceValueCategory => sourceValueCategory.label,
        dataTestId: `${this.dataTestId}-MultiplexInput`,
        disabled: this.props.isReadonly,
        onChange: this.onSourceValueCategorySelected
      }, this._sourceValueCategories.map(sourceValueCategory => {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: sourceValueCategory.id
        }, sourceValueCategory.id === this.valueCategoryID ? this.editor : null);
      }));
    }
  }
  onSourceValueCategorySelected(sourceValueCategory) {
    Assert.assert(!this.props.isReadonly);
    if (this._sourceValueCategory !== sourceValueCategory) {
      if (this.context.expanded) {
        this.context.collapse();
      }
      const oldValueCategoryID = this.valueCategoryID;
      const newValueCategoryID = sourceValueCategory.id;
      this._sourceValueCategory = sourceValueCategory;
      if (this.props.operandValue != null) {
        const operandValue = this.props.customizationFunctions?.coerceOperandValueToNewCategory?.(this.props.operandValue, oldValueCategoryID, newValueCategoryID);
        this.props.applyOperandValue(operandValue);
      }
    }
  }
  get sourceOperandValueEditorProps() {
    // <hack>
    // This is a hack to avoid an exception in BRE code caused by a race-like condition:
    // In onSourceValueCategorySelected above, this component's category gets modified and
    // the operand value gets applied. The application, however, is sometimes done behind
    // promises, and things can get out of sync. This ensures we don't try to render an
    // operand value with another category's editor.
    let operandValue = this.props.operandValue;
    if (!GuidedExpressionEditorUtils.operandValueMatchesCategoryForEditor(operandValue, this.valueCategoryID)) {
      operandValue = undefined;
    }
    // </hack>
    const baseProps = {
      operandName: this.props.operandName,
      operandValue: operandValue,
      expressionDomainModel: this.props.expressionDomainModel,
      liveViewSliceModel: this.props.liveViewSliceModel,
      dataTestId: this.dataTestId,
      displayProps: this.displayProps,
      generateId: this.props.generateId,
      operatorOperandValue: this.props.operatorOperandValue,
      expTemplateConfiguration: this.props.expTemplateConfiguration
    };
    if (this.props.isReadonly) {
      return {
        isReadonly: true,
        ...baseProps
      };
    } else {
      return {
        isReadonly: false,
        ...baseProps,
        customizationFunctions: this.props.customizationFunctions,
        setDragDropEditorMachine: this.setDragDropEditorMachine,
        applyOperandValue: this.props.applyOperandValue
      };
    }
  }
  get displayProps() {
    const showClearButtonIfSupported = this._sourceValueCategory != null ? this.props.componentFactory.getShowClearButtonIfSupported?.(this._sourceValueCategory.id) : undefined;
    return {
      debouncerActivityWindowMillis: this.props.componentFactory.debouncerActivityWindowMillis,
      showClearButtonIfSupported: showClearButtonIfSupported,
      forwardFocusRef: this._forwardFocusRef
    };
  }
  setDragDropEditorMachine(dragDropEditorMachine) {
    this._dragDropEditorMachine = dragDropEditorMachine;
  }
}, _defineProperty(_SourceOperandValueEditor, "contextType", InlinePanelLayout.ExpansionContext), _SourceOperandValueEditor), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "_sourceValueCategory", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "_dragDropEditorMachine", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "dataTestId", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "dataTestId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "valueCategoryID", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "valueCategoryID"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "initialize", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "initialize"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "editor", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "editor"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSourceValueCategorySelected", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "onSourceValueCategorySelected"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sourceOperandValueEditorProps", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sourceOperandValueEditorProps"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "displayProps", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "displayProps"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setDragDropEditorMachine", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "setDragDropEditorMachine"), _class2.prototype), _class2)) || _class);
export function SourceOperandValueEditorWithManagedFocus(props) {
  const {
    rowKey
  } = props;
  const targetRep = useMemo(() => new AbBooleanLogicTreeFocus.SourceTarget(rowKey ?? ""), [rowKey]);
  const sourceOperandValueEditor = useComponentWithManagedFocus(SourceOperandValueEditor, targetRep);
  return sourceOperandValueEditor(props);
}
class SourceValueCategoryImpl {
  constructor(expValueCategory) {
    _defineProperty(this, "id", void 0);
    _defineProperty(this, "label", void 0);
    _defineProperty(this, "selectorLabel", void 0);
    this.id = expValueCategory.id;
    this.label = expValueCategory.label;
    this.selectorLabel = expValueCategory.selectorLabel;
  }
}
class FunctionSourceValueCategoryImpl {
  constructor() {
    _defineProperty(this, "id", Expression.Domain.Constants.PSEUDO_CATEGORY_FUNCTION);
    _defineProperty(this, "label", Expression.Domain.Constants.PSEUDO_CATEGORY_FUNCTION_LABEL);
  }
}
//# sourceMappingURL=SourceOperandValueEditor.js.map
